import React from 'react';
import {colors} from '../styles/colors';
import {translate} from 'react-i18next';
import ArrowBack from 'material-ui-icons/ArrowBack';
import {navigationBack} from '../navigation/NavigationActions';
import {connect} from 'react-redux';
import MyButton from '../components/MyButton';
import TextField from 'material-ui/TextField';
import {
	INCOMPLETE_DATA,
	INTERRUPT_NOT_ALLOWED,
	NO_INTERRUPT_WHILE_INTERRUPTED,
	INTERRUPT_NOT_ALLOWED_CHEATED,
} from '../utils/constants';
import InfoSnack from '../utils/InfoSnack';
import {fetchPause} from './PauseAction';
import './PauseScreen.css';
import Header from '../components/Header';

class PauseScreen extends React.PureComponent {
	constructor() {
		super();

		this.state = {
			countDays: 3,
		};
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.pauseSuccess !== this.props.pauseSuccess &&
			prevProps.pauseLoading
		) {
			if (this.props.pauseSuccess.msg === INCOMPLETE_DATA) {
				this.infoSnack.showSnack(this.props.t('pause:failed'));
			}

			if (this.props.pauseSuccess.msg === INTERRUPT_NOT_ALLOWED) {
				if (this.props.betMode == 2) {
					this.infoSnack.showSnack(this.props.t('pause:notAllowed'));
				} else {
					this.infoSnack.showSnack(
						this.props.t('pause:notAllowedOld')
					);
				}
			}

			if (this.props.pauseSuccess.msg === INTERRUPT_NOT_ALLOWED_CHEATED) {
				this.infoSnack.showSnack(
					this.props.t('pause:notAllowedCheated')
				);
			}
			if (
				this.props.pauseSuccess.msg === NO_INTERRUPT_WHILE_INTERRUPTED
			) {
				this.infoSnack.showSnack(
					this.props.t('pause:noPauseWhilePause')
				);
			}
		} else if (
			prevProps.loadingPauseFailed !== this.props.loadingPauseFailed &&
			prevProps.pauseLoading
		) {
			this.infoSnack.showSnack(this.props.t('common:cell_failed'));
		}
	}

	handleChange = (name) => (event) => {
		this.setState({
			[name]: event.target.value,
		});
	};

	pause = () => {
		this.props.fetchPause(this.state.countDays);
	};

	render() {
		const {t} = this.props;
		return (
			<div className='pauseScreenWrapper'>
				<InfoSnack onRef={(ref) => (this.infoSnack = ref)} />
				<Header
					onBackPress={() => this.props.goBack()}
					title={t('pause:title')}
				/>
				<div style={styles.shareContainer}>
					<h2 style={{color: colors.white}}>{t('pause:subTitle')}</h2>
					<br />
					<p style={{color: colors.white}}>
						{t('pause:titleDescription')}
					</p>
					<br />
					<div className='inputContainer bottomGutterLarge'>
						<label htmlFor='daysoff' className='inputLabel'>
							{t('pause:count')}
						</label>
						<input
							style={{outline: 'none'}}
							className='formInput'
							id='daysoff'
							type='number'
							value={this.state.countDays}
							onChange={this.handleChange('countDays')}
						/>
					</div>
					<div style={{marginTop: 30}}>
						<MyButton
							title={t('pause:requestPause')}
							style={{
								color: colors.primaryColor,
								background: colors.white,
							}}
							variant='raised'
							size='large'
							color='primary'
							fullWidth={true}
							loading={this.props.pauseLoading}
							onPressButton={() => this.pause()}
						/>
					</div>
				</div>
			</div>
		);
	}
}

const styles = {
	textInput: {
		paddingTop: 10,
	},
	shareContainer: {
		maxWidth: 512,
		margin: '0 auto',
		paddingTop: 72,
		paddingRight: 16,
		paddingLeft: 16,
	},
	flex: {
		flex: 1,
	},
};

const mapStateToProps = (state) => {
	return {
		pauseLoading: state.pauseLoading,
		pauseSuccess: state.pauseSuccess,
		loadingPauseFailed: state.loadingPauseFailed,
		betMode: state.betMode,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchPause: (countDays) => dispatch(fetchPause(countDays)),
		goBack: () => dispatch(navigationBack()),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(translate(['pause', 'common'])(PauseScreen));



// WEBPACK FOOTER //
// ./src/pause/PauseScreen.js